import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchItems } from "../../actions/records";
import { getMyCustomers, getMySuppliers } from "../../actions/submissions";
import DropDown from "../widgets/dropdown";
import Swal from "sweetalert2";
import colors from "../../constants/colors";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { sortSearch } from "../../utils";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
import InventoryTransferItemModal from "../InventoryTransferItemModal";
import { unwrapLocationValue } from "../../utils/inventoryTransferLocationTree";
class SearchItems extends Component {
    constructor(props) {
        super(props);
        this._interval = null;
        const initialLabel = props.initial && typeof props.initial === "object"
            ? (props.initial.itemName || props.initial.item || "")
            : (props.initial ? props.initial : "");
        this.state = {
            value: initialLabel,
            supplierSelected: props.initial ? props.initial : "",
            height: 30,
            items: [],
            filteredSuppliers: [],
            wasEdited: false,
            openList: false,
            showTransferItemModal: false,
        };
        this.textInputRef = createRef(null);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.initial != this.props.initial){
            const nextValue = nextProps.initial && typeof nextProps.initial === "object"
                ? (nextProps.initial.itemName || nextProps.initial.item || "")
                : nextProps.initial;
            this.setState({ value: nextValue });
        }
        if (nextProps.closeSearch != this.props.closeSearch && !this.textInputRef.current?.isFocused()){
          this.setState({ items: [], wasEdited: false });
          if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
        }
    }
    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval);
        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
    }
    formatSuppliers(suppliers){
        var formatedSuppliers = suppliers.map((sup,idx)=>{
            return {
                id: idx+1,
                value: sup.name
            }
        });

        return formatedSuppliers;
    }
    searchItems(val, focused) {
        const { onSelectItem, customers, company_id, isShipmentLog, suppliers, isInventoryTransfer, isRecipe, resetDropDown } = this.props;
        const { items } = this.state;
        if(this._interval)clearInterval(this._interval);
        if(val || focused){
            if(customers){
                this.props.getMyCustomers({ page: 1, name: val, company_id }, (res) => {
                    if(res?.customers?.length > 0){
                        this.setState({ items: res?.customers });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(true);
                    }else{
                        this.setState({ items: [] });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                    }
                });
            }else if(suppliers){
                this.props.getMySuppliers(company_id, 1, { name: val }, (res) => {
                    if(res?.suppliers?.length > 0){
                        this.setState({ items: res?.suppliers });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(true);
                    }else{
                        this.setState({ items: [] });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                    }
                });
            }else{
                var itemsData = { page: 1, name: val };
                if(isShipmentLog)itemsData.fromShipmentLog = true;
                if(isRecipe)itemsData.forRecipe = true;
                this.props.searchItems(itemsData, (res) => {
                    if(res?.items?.length > 0){
                        const ordered = res?.items.slice().sort((a, b) => sortSearch(a, b, val));
                        this.setState({ items: ordered });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(true);
                    }else{
                        this.setState({ items: [] });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                    }
                    if(resetDropDown)resetDropDown();
                });
            }
        }else{
            this.setState({ items: [] });
            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
            if(isInventoryTransfer && !focused)onSelectItem(val);
        }
        if(!focused)onSelectItem(val, null); 
    }
    alertConfirm(msg, conf) {
        Swal.fire({
            text: msg,
            confirmButtonText: conf,
            confirmButtonColor: '#0B4DA0',
            backdrop: false
        });
    }
    openTransferItemModal() {
        this.setState({ showTransferItemModal: true });
    }
    /** Completed transfers are view-only unless reopened as edit_required. */
    isInventoryTransferModalReadOnly() {
        const { complete_date, defaultComponent, submissionStatus } = this.props;
        if (submissionStatus === "edit_required") return false;
        if (complete_date) return true;
        return !!defaultComponent;
    }
    getTransferItemLabel(val) {
        if (val && typeof val === "object") {
            return val.itemName || val.item || "";
        }
        return val || "";
    }
    getRowFieldValue(defaultLabels) {
        const { components, submission, position, id } = this.props;
        if (!components || !submission) return null;
        const self = components.find((c) => c.id == id);
        const section_id = self?.section_id;
        if (section_id == null) return null;
        const labels = Array.isArray(defaultLabels) ? defaultLabels : [defaultLabels];
        const component = components.find(
            (c) => c.section_id == section_id && labels.includes(c.defaultLabel)
        );
        if (!component) return null;
        const raw = submission[component.id];
        if (raw == null) return null;
        if (position || position == 0) return raw[position];
        return Array.isArray(raw) ? raw[0] : raw;
    }
    onTransferItemModalSave(rows) {
        const { onInventoryTransferLocationSave, position } = this.props;
        this.setState({ showTransferItemModal: false });
        if (onInventoryTransferLocationSave) {
            onInventoryTransferLocationSave(rows, position);
        }
    }
    /** Legacy single-item select (non-transfer flows). */
    onTransferItemSelected(selected) {
        const { onSelectItem } = this.props;
        const name = selected?.itemName || selected?.item || "";
        this.setState({
            value: name,
            showTransferItemModal: false,
            items: [],
            wasEdited: false,
        });
        if (onSelectItem) onSelectItem(name, selected);
    }
    render(){
        const { value, items, wasEdited, filteredSuppliers, openList, showTransferItemModal } = this.state;
        const { defaultComponent, onSelectItem, placeholder, customers, isShipmentLog, suppliers, isInventoryTransfer, width, onFocus, isRecipe, defaultLabel, isInventoryReceivingForm, inventoryTableDesign, setShowTextBar, inventoryLocations, complete_date, initial } = this.props;
        const inventoryTableCellDesign = !!(isInventoryReceivingForm || inventoryTableDesign);
        const transferSearchPill = !!(isInventoryTransfer && inventoryTableDesign && !customers && !suppliers);
        const transferItemLabel = this.getTransferItemLabel(value) || this.getTransferItemLabel(initial);
        const selectedTransferItem = (value && typeof value === "object") ? value : (initial || value);
        const fromLocationValue = unwrapLocationValue(this.getRowFieldValue("fromLocation"));
        const toLocationValue = unwrapLocationValue(this.getRowFieldValue("toLocation"));
        const initialLotcodes = this.getRowFieldValue("lotcode");
        return <View>
            {showTransferItemModal ? (
                <InventoryTransferItemModal
                    inventoryLocations={inventoryLocations || []}
                    complete_date={complete_date}
                    readOnly={this.isInventoryTransferModalReadOnly()}
                    selectedItem={selectedTransferItem}
                    initialLotcodes={initialLotcodes}
                    fromLocation={fromLocationValue}
                    toLocation={toLocationValue}
                    submission={this.props.submission}
                    components={this.props.components}
                    position={this.props.position}
                    onClose={() => this.setState({ showTransferItemModal: false })}
                    onSave={(rows) => this.onTransferItemModalSave(rows)}
                    onSelect={(selected) => this.onTransferItemSelected(selected)}
                />
            ) : null}
            {transferSearchPill ? (
                <TouchableOpacity
                    onPress={() => this.openTransferItemModal()}
                    style={{
                        borderRadius: 20,
                        borderWidth: transferItemLabel ? 1.5 : 0,
                        borderColor: transferItemLabel ? colors.orange : colors.primary,
                        backgroundColor: transferItemLabel ? "#fff" : colors.primary,
                        paddingVertical: 8,
                        paddingHorizontal: 12,
                        minHeight: 36,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Text
                        numberOfLines={2}
                        style={{
                            color: transferItemLabel ? "#222" : "#fff",
                            fontSize: 14,
                            fontFamily: "Roboto",
                            textAlign: "center",
                        }}
                    >
                        {transferItemLabel || "Search"}
                    </Text>
                </TouchableOpacity>
            ) : (
            <TextInput
                {...getNoAutofillProps()}
                value={value}
                ref={noAutofillRef(this.textInputRef)}
                editable={!defaultComponent}
                onContentSizeChange={(event) => {
                    //console.log(event.nativeEvent.contentSize);
                    if (event.nativeEvent.contentSize.height == 0) {
                        if (this.props.placeholder == '') {
                            this.setState({ height: 30 })
                        }
                        this.setState({ height: event.nativeEvent.contentSize.height });
                    } else {
                        setTimeout(() => {
                            this.setState({ height: event.nativeEvent.contentSize.height });
                        }, 5)
                    }
                }}
                onFocus={()=> {
                    if(onFocus)onFocus();
                    if(!defaultComponent && !value){
                        if(this._interval)clearInterval(this._interval);
                        this._interval = setInterval(() => this.searchItems(value ? value : "", true), 500);
                    }
                    /* Same as iqops2: clear KeyboardBar when focus moves to a non-lot search field */
                    if (setShowTextBar && (isMobileWeb() || Platform.OS === "android")) {
                        setShowTextBar(null, null, null, null, null, null, null, false);
                    }
                }}
                style={{...styles.input,
                    borderColor: "#e7e7e7",
                    borderRadius: 5,
                    borderWidth: ((inventoryTableCellDesign && defaultLabel == "yield") || (inventoryTableCellDesign && width && defaultLabel != "preparationInstructions")) ? 0 : 1,
                    color: "#424242",
                    fontFamily: "Roboto",
                    fontSize: inventoryTableCellDesign ? 16 : 20,
                    fontWeight: "400",
                    padding: 5,
                    height: this.state.height,
                    fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                    overflow: 'hidden',
                    textAlign: inventoryTableCellDesign ? 'center' : 'left',
                }}
                multiline={true}
                placeholder={placeholder ? placeholder : ""}
                placeholderTextColor={customers || suppliers ? colors.orange : 'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                    if (val == '' && this.props.placeholder == '') {
                        this.setState({ value: val, height: 30, wasEdited: true });

                    } else {
                        this.setState({ value: val, wasEdited: true });
                    }
                    if(this._interval)clearInterval(this._interval);
                    this._interval = setInterval(() => this.searchItems(val, false), 500);
                }}
            />
            )}
            {
                !transferSearchPill && items?.length > 0 &&
                    items.map((item, idx) =>{
                        return <TouchableOpacity key={idx} style={{...styles.row, gridTemplateColumns: customers ? "95% 5%" : width == "mini" ? "80% 20%" : "87% 10%"}} onPress={() => {
                            if(isInventoryTransfer){
                                if(item?.items?.length <= 0 && typeof item?.items == "object"){
                                    this.alertConfirm(item.item + " does not have lot codes available to transfer.", "Accept");
                                }else{
                                    onSelectItem(item?.itemName, item)
                                    this.setState({ items: [],value: item?.itemName, wasEdited: false});
                                }
                            }else if(customers || suppliers){
                                onSelectItem(item?.name)
                                this.setState({ items: [],value: item?.name, wasEdited: false});
                            }else if(isShipmentLog){
                                var newItem = JSON.parse(JSON.stringify(item));
                                //newItem.lotSelected = ["default_lot"]; 
                                onSelectItem(item?.itemName, newItem);
                                this.setState({ items: [],value: item?.itemName, wasEdited: false});
                            }else{
                                onSelectItem(item?.itemName, item);
                                this.setState({ items: [],value: item?.itemName, wasEdited: false});
                            }
                            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                            
                        }}>
                            <div style={styles.itemTxt}>
                                {customers ? item?.name : suppliers ? item?.name : item?.itemName}
                            </div>
                            <div style={styles.addBtnContainer}>
                                <div style={styles.rowBtn} > <Text>
                                    <MaterialCommunityIcons name="plus" style={styles.selectOption} />
                                </Text> 
                                </div>
                            </div>
                            
                        </TouchableOpacity>
                    })
            }
            {/* {
                suppliers && items?.length > 0 &&
                <DropDown
                  initialOption={ typeof filteredSuppliers.find(x => x.value == this.state.supplierSelected) === 'undefined'  ? "" : {value:  this.state.supplierSelected }}
                  updated={this.state.supplierSelected}
                  options={filteredSuppliers}
                  defaultComponent={defaultComponent}
                  openList={openList}
                  onSelect={(option) => {
                      onSelectItem(option?.value)
                  }}
                />
            } */}
            {
                !transferSearchPill && (value && items?.length <= 0 && wasEdited) ? <View>
                    <Text>No {customers ? 'customers' : 'items'} were found</Text>
                </View> : null
            }

        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
    company_id: state.user.get("company_id"),
    submissionStatus: state.submissions.get("submissionSelected")?.status,
}), (dispatch, props) => ({
    searchItems: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchItems(formid, saveAsTemplate, saveAsForm, callback)),
    getMyCustomers: (data, callback) =>
        dispatch(getMyCustomers(data, callback)), 
    getMySuppliers: (id, page, filter, callback) =>
        dispatch(getMySuppliers(id, page, filter, callback)),
}))(SearchItems);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row:{
        display: "grid",
        width: "100%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn:{
        color: colors.selectSearch,
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    selectOption: { 
        fontSize: 20, 
        color: colors.selectSearch 
    },
    addBtnContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    itemTxt: {
        wordBreak: 'word-break',
        padding: 3
    }
});